<template>
  <div class="wrapper">
    <lastpage></lastpage>
    <div class="brief_introduction">
      <div>
        <img src="@/assets/appointment/doctor_icon.png">
        <div>
          <p>{{ doctorInfo.DoctorName }}</p>
          <p>{{ doctorInfo.DeptName }}/{{ doctorInfo.LabelName }}</p>
        </div>
      </div>
      <div>
        <span>擅长：{{ zsdata }}</span>
        <img :src="bg_url" @click="showtext" v-if="textOver" >
      </div>
    </div>
    <ul class="timeSel">
      <li v-for="(item,index) in date" :key="index" @click="handleTab(index,item)" :class="current == index?`list_xuan`:` `">
        <span>{{ item.week }}</span>
        <span>{{ item.day }}</span>
        <span :class="current == index?`selectTriangle`:` `"></span>
      </li>
    </ul>
    <ul v-if="showDuty" class="dataSel">
      <li class="title">{{ doctorInfo.DeptName }}</li>
      <li v-if="timeList.morning.list.length != 0">
        <span>上午</span>
        <span>挂号费：￥{{ doctorInfo.Fee }}</span>
        <span @click="btnSel(1)">余号：{{ timeList.morning.AllRegRemained }}</span>
      </li>
      <li v-if="timeList.afternoon.list.length != 0">
        <span>下午</span>
        <span>挂号费：￥{{ doctorInfo.Fee }}</span>
        <span @click="btnSel(2)">余号：{{ timeList.afternoon.AllRegRemained }}</span>
      </li>
      <li v-if="timeList.night.list.length != 0">
        <span>晚上</span>
        <span>挂号费：￥{{ doctorInfo.Fee }}</span>
        <span @click="btnSel(3)">余号：{{ timeList.night.AllRegRemained }}</span>
      </li>
    </ul>
    <van-popup v-model="showzs" round position="bottom">
      <div class="title_top">{{ nowdate.replace(/\./g, "月") }}日 {{ today }} 上午</div>
      <ul class="time_list">
        <li @click="datebtn(item)" v-for="(item,index) in timeList.morning.list" :key="index">
          <span>{{ item.TimeDesc }}</span>
          <span>余号:{{ item.RegRemained }}</span>
        </li>
      </ul>
    </van-popup>
    <van-popup v-model="showxw" round position="bottom">
      <div class="title_top">{{ nowdate.replace(/\./g, "月") }}日 {{ today }} 下午</div>
      <ul class="time_list">
        <li @click="datebtn(item)" v-for="(item,index) in timeList.afternoon.list" :key="index">
          <span>{{ item.TimeDesc }}</span>
          <span>余号:{{ item.RegRemained }}</span>
        </li>
      </ul>
    </van-popup>
    <van-popup v-model="showws" round position="bottom">
      <div class="title_top">{{ nowdate.replace(/\./g, "月") }}日 {{ today }} 晚上</div>
      <ul class="time_list">
        <li @click="datebtn(item)" v-for="(item,index) in timeList.night.list" :key="index">
          <span>{{ item.TimeDesc }}</span>
          <span>余号:{{ item.RegRemained }}</span>
        </li>
      </ul>
    </van-popup>
    <div v-if="!showDuty" class="null_doctor">
      当日暂无值班
    </div>
  </div>
</template>

<script>
import { getDoctorScheduleTime } from "@/request/api.js";
import upper from "@/assets/appointment/jts_icon.png";
import lower from "@/assets/appointment/jtx_icon.png";
import lastpage from "@/components/lastpage/lastpage.vue";
export default {
  components: {
    lastpage
  },
  data() {
    return {
      current: 0,
      showzs: false,
      showxw: false,
      showws: false,
      bg_url: lower,
      textOver: false,
      advantages: "",
      zsdata: "",
      doctorInfo: {},
      nowdate: null,
      today: null,
      year: null,
      date: [],
      timeList: {
        morning: {},
        afternoon: {},
        night: {}
      },
      showDuty: false,
      hspCode: sessionStorage.getItem("hspCode"),
    };
  },
  created() {
    this.doctorInfo = JSON.parse(sessionStorage.getItem("doctorInfo"));
    this.advantages = this.doctorInfo.Description == ''?'信息正在录入中...':this.doctorInfo.Description;
    this.getDate();
    this.textellipsis();
    this.today = this.getWeek();
    this.nowdate = (sessionStorage.getItem("clinicDate").slice(5,10)).replace(/\-/g, ".")
    this.getTime(sessionStorage.getItem("clinicDate"));
    this.current = sessionStorage.getItem("current")?sessionStorage.getItem("current"):0;
  },
  // beforeRouteEnter(to, from, next) {
  //   next((vm) => {
  //     // vm就是this
  //     // beforeRouteEnter不能通过this访问组件实例，但是可以通过 vm 访问组件实例 ; vm就相当于this!!!!
  //     // vm.formUrl = from.path;
  //     if(from.path == "/ChooseDoctor"){
  //       vm.$router.go(0);
  //     }
  //   })
  // },
  activated() {
    this.getTime()
  },
  methods: {
    getWeek () {
      let week = this.$moment(sessionStorage.getItem("clinicDate").replace(/\-/g, "/")).day();
      switch (week) {
        case 1:
          return '星期一'
        case 2:
          return '星期二'
        case 3:
          return '星期三'
        case 4:
          return '星期四'
        case 5:
          return '星期五'
        case 6:
          return '星期六'
        case 0:
          return '星期日'
      }
    },
    // 获取时间
    getDate(){
      this.year = this.$moment().format('YYYY')
      for(let i=0;i<7;i++){
        let str = this.$moment().add(i,'days').format('dddd,M.DD');
        let ary = str.split(",");
        let wk = "";
        let today = "";
        switch (ary[0]) {
          case "Monday":
            wk = '周一'
            today = '星期一'
            break;
          case "Tuesday":
            wk = '周二'
            today = '星期二'
            break;
          case "Wednesday":
            wk = '周三'
            today = '星期三'
            break;
          case "Thursday":
            wk = '周四'
            today = '星期四'
            break;
          case "Friday":
            wk = '周五'
            today = '星期五'
            break;
          case "Saturday":
            wk = '周六'
            today = '星期六'
            break;
          case "Sunday":
            wk = '周日'
            today = '星期日'
            break;
          default:
            break;
        }
        if(i==0){
          this.date.push({week: '今天',day: ary[1],today})
        } else {
          this.date.push({week: wk,day: ary[1],today})
        }
      }
      if(!this.nowdate){
        this.nowdate = this.date[0].day
        this.today = this.date[0].today
      }
    },
    // 获取医生可挂号时间段
    async getTime(time){
      let date = ""
      if(time == undefined){
        date = (this.year+"."+this.nowdate).replace(/\./g, "-")
      } else {
        date = time
      }
      sessionStorage.setItem("clinicDate",date)
      let map = {
        clinicDate: this.$moment(date.replace(/\-/g, "/")).format('YYYY-MM-DD'),
        deptID: this.doctorInfo.DeptID,
        doctorId: this.doctorInfo.DoctorId,
        hspCode: this.hspCode,
        userId: "7148",
        workType: this.doctorInfo.workType
      }
      let res = await getDoctorScheduleTime(map)
      if(res.data.message == "操作成功"){
        this.timeList = {
          morning: {},
          afternoon: {},
          night: {}
        }
        this.timeList.morning.list = []
        this.timeList.morning.AllRegRemained = 0
        this.timeList.afternoon.list = []
        this.timeList.afternoon.AllRegRemained = 0
        this.timeList.night.list = []
        this.timeList.night.AllRegRemained = 0
        res.data.obj.resultData.forEach(item => {
          let ary = item.TimeDesc.split(" ")
          switch (ary[0]) {
            case '上午':
              this.timeList.morning.AllRegRemained+=item.RegRemained
              ary[1] = ary[1].replace(/-/g, "~")
              this.timeList.morning.list.push({TimeId: item.TimeId,TimeDesc: ary[1],RegRemained: item.RegRemained,resultData: item})
              break;
            case '下午':
              this.timeList.afternoon.AllRegRemained+=item.RegRemained
              ary[1] = ary[1].replace(/-/g, "~")
              this.timeList.afternoon.list.push({TimeId: item.TimeId,TimeDesc: ary[1],RegRemained: item.RegRemained,resultData: item})
              break;
            case '晚上':
              this.timeList.night.AllRegRemained+=item.RegRemained
              ary[1] = ary[1].replace(/-/g, "~")
              this.timeList.night.list.push({TimeId: item.TimeId,TimeDesc: ary[1],RegRemained: item.RegRemained,resultData: item})
              break;
            default:
              break;
          }
        });
        this.showDuty = true
      } else {
        this.showDuty = false
        this.timeList = {
          morning: {},
          afternoon: {},
          night: {}
        }
      }
    },
    handleTab(index,item){
      this.current = index
      this.nowdate = item.day
      this.today = item.today
      // this.$nextTick(() => {
      //   this.getTime()
      // })
      this.getTime()
    },
    // 字体省略
    textellipsis(){
      if(this.advantages.length > 38){
        this.textOver = true
        this.zsdata = this.advantages.substring(0,38)+"...";
      } else {
        this.zsdata = this.advantages
      }
    },
    // 展开
    showtext(){
      if(this.bg_url == lower){
        this.bg_url = upper;
        this.zsdata = this.advantages;
      } else {
        this.bg_url = lower;
        this.zsdata = this.advantages.substring(0,38)+"...";
      }
    },
    makebtn(){
      this.$router.push("/ChooseTime")
    },
    btnSel(num){
      switch (num) {
        case 1:
          this.showzs = true
          sessionStorage.setItem("timeData2",JSON.stringify({today: this.today,wu: "上午"}))
          break;
        case 2:
          this.showxw = true
          sessionStorage.setItem("timeData2",JSON.stringify({today: this.today,wu: "下午"}))
          break;
        case 3:
          this.showws = true
          sessionStorage.setItem("timeData2",JSON.stringify({today: this.today,wu: "晚上"}))
          break;
        default:
          break;
      }
    },
    datebtn(item){
      console.log(sessionStorage.setItem("current",this.current))
      sessionStorage.setItem("timeData",JSON.stringify(item.resultData))
      this.$router.push("/AppointmentDetails")
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: #F8F8F8;
  .van-popup{
    .title_top{
      font-size: 17px;
      font-weight: bold;
      line-height: 45px;
      background: #1C96CB;
      text-align: center;
      color: #fff;
    }
    .time_list{
      padding: 6px 19px 48px;
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
      >li{
        display: flex;
        flex-flow: column nowrap;
        margin-top: 14px;
        width: 106px;
        height: 53px;
        background: #DDEFF6;
        font-size: 12px;
        color: #1C96CB;
        justify-content: center;
        align-items: center;
      }
    }
  }
  .brief_introduction{
    letter-spacing: 1px;
    color: #fff;
    // margin-top: 10px;
    padding: 21px 17px 21px 19px;
    background: linear-gradient(180deg, #5BB3D9 0%, #1C96CB 100%);
    >div:nth-child(1){
      display: flex;
      flex-flow: row nowrap;
      >img{
        width: 38px;
        height: 46px;
      }
      >div{
        margin-left: 16px;
        font-size: 13px;
        >p:nth-child(1){
          margin: 3px 0px 3px;
          font-size: 17px;
          font-weight: bold;
        }
      }
    }
    >div:nth-child(2){
      position: relative;
      margin-top: 19px;
      font-size: 12px;
      >img{
        position: absolute;
        right: 12px;
        bottom: 0px;
        width: 12px;
        height: 8px;
      }
    }
  }
  .timeSel{
    display: flex;
    flex-flow: row nowrap;
    margin-top: 10px;
    background: #fff;
    height: 78px;
    font-size: 15px;
    >li{
      position: relative;
      flex: 1;
      display: flex;
      flex-flow: column nowrap;
      text-align: center;
      height: 100%;
      justify-content: center;
      >span:nth-child(1){
        margin-bottom: 13px;
      }
      .selectTriangle{
        transition: all .6s;
        position: absolute;
        width: 32px;
        height: 5px;
        left: calc(50% - 16px);
        bottom: 2px;
        background: #1C96CB;
        border-radius: 3px;
        margin: 0px !important;
      }
    }
    .list_xuan{
      transition: all .6s;
      color: #1C96CB;
    }
  }
  .dataSel{
    margin-top: 14px;
    background: #fff;
    >li{
      display: flex;
      flex-flow: row nowrap;
      padding: 13px 14px;
      border-bottom: 1px solid #DFDFDF;
      color: #707070;
      align-items: center;
      >span:nth-child(1){
        margin-right: 40px;
      }
      >span:nth-child(2){
        flex: 1;
      }
      >span:nth-child(3){
        padding: 7px 11px;
        background: #1C96CB;
        border-radius: 19px;
        color: #fff;
      }
    }
    .title{
      font-size: 15px;
      font-weight: bold;
      color: #000;
    }
  }
  .null_doctor{
    text-align: center;
    padding: 60px 0px;
    font-size: 20px;
    font-weight: bold;
    color: #999;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Index/ChooseTime.vue